import { useRootStore } from '@pinia/index';
import { useSessionStore } from '@pinia/session';

export default () => {
  const root = useRootStore();
  const sessionStore = useSessionStore();

  const executeApiCall: typeof root.paymentService.executeApiCall = (method, requestMessage) => {
    const metadata = new Headers();
    if (sessionStore.token != null) {
      metadata.set('authorization', `Bearer ${sessionStore.token}`);
    }
    return root.paymentService.executeApiCall(method, requestMessage, metadata);
  };

  return {
    executeApiCall,
    client: null,
  };
};
